import script from "./select-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./select-item.vue?vue&type=script&setup=true&lang=ts"

import "./select-item.vue?vue&type=style&index=0&id=ce086ade&lang=scss"

const __exports__ = script;

export default __exports__